import { render, staticRenderFns } from "./BoardEmptyDefaultLayout.vue?vue&type=template&id=4c300e1d&scoped=true&"
import script from "./BoardEmptyDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BoardEmptyDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c300e1d",
  null
  
)

export default component.exports